import ButtonSecondary from "shared/Button/ButtonSecondary";
import { useNavigate } from "react-router-dom";

type Props = {
  isLoading: boolean;
};

export const NotFoundHotel = ({ isLoading }: Props) => {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate("/home");
  };

  return (
    <div className="flex justify-center items-center w-full h-[calc(100svh-240px)]">
      <div className="">
        <h1 className="text-2xl font-semibold text-neutral-700 dark:text-neutral-300">
          {isLoading ? (
            <div className="flex flex-col items-center space-y-5">
              <h1 className="w-4/5 md:w-full text-center md:text-start text-2xl font-semibold text-neutral-700 dark:text-neutral-300">
                Buscando detalhes do hotel para você
              </h1>

              <div className="flex space-x-2">
                {Array.from({ length: 3 }).map((_, i) => {
                  return (
                    <div
                      key={`item-${i}`}
                      className="w-2 h-2 bg-neutral-700 rounded-full animate-bounce"
                    ></div>
                  );
                })}
              </div>
            </div>
          ) : (
            <div className="flex flex-col items-center ">
              <h1 className="text-2xl font-semibold text-neutral-700 dark:text-neutral-300">
                Nenhum hotel encontrado
              </h1>

              <span className="text-sm text-red-400 mt-2 mb-6">
                Verifique se o hotel está disponível para a data selecionada
              </span>

              <ButtonSecondary onClick={handleBack}>Voltar</ButtonSecondary>
            </div>
          )}
        </h1>
      </div>
    </div>
  );
};
